/**
 * Bridge Service - React Native WebView ile iletişim altyapısı
 *
 * Native'e mesaj gönderme:
 *   bridge.send('LOGIN_SUCCESS', { token, user, subdomain })
 *
 * Native'den mesaj dinleme:
 *   const unsubscribe = bridge.on('PUSH_TOKEN', (payload) => { ... })
 *   unsubscribe() // dinlemeyi bırak
 */

class BridgeService {
  constructor() {
    this.listeners = new Map();
    this._initListener();
  }

  get isNative() {
    return !!window.ReactNativeWebView;
  }

  _initListener() {
    window.addEventListener('message', (event) => {
      try {
        const message = typeof event.data === 'string' ? JSON.parse(event.data) : event.data;
        if (message && message.type) {
          const callbacks = this.listeners.get(message.type);
          if (callbacks) {
            callbacks.forEach(cb => cb(message.payload));
          }
        }
      } catch (e) {
        // JSON parse hatası — native olmayan mesajları yoksay
      }
    });
  }

  send(type, payload) {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
    }
  }

  on(type, callback) {
    if (!this.listeners.has(type)) {
      this.listeners.set(type, new Set());
    }
    this.listeners.get(type).add(callback);

    return () => {
      const callbacks = this.listeners.get(type);
      if (callbacks) {
        callbacks.delete(callback);
        if (callbacks.size === 0) {
          this.listeners.delete(type);
        }
      }
    };
  }
}

const bridge = new BridgeService();

export default bridge;
